import { getDoc, getDocs } from 'firebase/firestore/lite';
import { from } from 'rxjs';
export function fromRef(ref) {
    if (ref.type === 'document') {
        return from(getDoc(ref));
    }
    else {
        return from(getDocs(ref));
    }
}
